import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({typography,variables}) => ({
  list: {
    margin: 0,
    padding: variables?.spacingD,
    listStyle: 'none',
    '& li': {
      margin: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingD}`,
      '&:last-child': {
        margin: 0,
      },
    },
  },
  upcommingDelivery: {
    padding: '0 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: typography.body1.fontSize,
    fontWeight: 700,
    gap: variables?.spacingB,
    '&.mobile': {
        padding: '10px 0px'
    }
  },


}
));

export default styles;
